import React from 'react';
import PropTypes from 'prop-types';

class Modal extends React.Component {
  render() {
    // Render nothing if the "show" prop is false
    if(!this.props.show) {
      return null;
    }

    // The gray background
    const backdropStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,0.3)',
      padding: 50,
      zIndex: 9999,
      overflow: 'auto'
    };

    // The modal "window"
    const modalStyle = {
      display: 'block',
      backgroundColor: '#fff',
      borderRadius: 5,
      maxWidth: 600,
      margin: '0 auto',
    };

    return (
      <div className="backdrop" style={backdropStyle} onClick={this.props.onClose}>
        <div className="modal-dialog">
            <div className="modal-content" style={modalStyle}>
                { this.props.title &&  <div className="modal-header text-center"> {this.props.title} </div> }
                <div className="modal-body">
                    {this.props.children}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={this.props.onClose}>Ok</button>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.jsx